import { call } from 'redux-saga/effects';
import { API } from '../../api';

export function* emailMarketing() {
  const path = '/email';
  const payload = {};
  yield call(API, 'post', 'api', path, payload);
}
